<template>
  <footer class="main-footer text-lg-start pt-4">
    <div class="desktop-footer-padding container p-4">
      <div class="row">
        <div class="col-lg-4 col-12 mb-lg-0">
          <img width="150" height="38.85" class="footer-logo" src="/images/logo1.webp" loading="lazy" alt="grapefroot icon" />
        </div>
        <div class="footer-sec col-lg-4 col-12 mb-4 mb-lg-0 px-3">
          <div class="rounded-circle d-flex align-items-center justify-content-center flex-column mx-auto footer-main">
            <h5 class="footer-sec-title text-uppercase mt-5 mb-2">What do you need?</h5>
            <ul class="list-unstyled text-center mt-4">
              <li><a href="/get-started" >How to get started</a></li>
              <li><a :href="portalLink" >Your Portal - login</a></li>
              <li><a :href="portalFaqsLink" >FAQs</a></li>
              <li><a href="/plans" >Plans</a></li>
              <li><a href="/blog" >Blogs</a></li>
              <li><a href="/contact-us" >Contact Us</a></li>
            </ul>
          </div>
        </div>
        <!-- <div class="col-lg-4 col-12 mb-2 mb-lg-0">
          <div class="desktop-social-section d-flex justify-content-between px-5 pt-3">
            <div class="desktop-social-icon">
              <a href="/" target="_blank">
                <img src="/images/instagram.webp" width="37" height="37" alt="Instagram icon" />
              </a>
            </div>
            <div class="desktop-social-icon">
              <a href="/" target="_blank">
                <img src="/images/fbicon.webp" width="37" height="37" alt="Facebook icon" />
              </a>
            </div>
          </div>
        </div> -->
      </div>
      <div class="footer-terms">
        <ul class="m-0 p-0 mb-2 text-center">
          <li><a  href="/privacy">Privacy Policy</a></li>
          <li><a  href="/cookies">Cookies</a></li>
          <li><a  href="/terms">Terms & Conditions</a></li>
        </ul>
      </div>
    </div>
    
    <div class="footer-bottom-bg text-center p-4 border-top border-white">
      Kashcow Ltd trading as Grapefroot. Kashcow Ltd is registered in the UK under company number 08889583
      <br /><br />
      Registered with the Information Commissioners Office ZA241727
      <br /><br />
      Registered address: Kashcow Ltd, 189 Chapel Street, Salford, M3 5EQ 
      <br /><br />
      Copyright © {{ currentYear }} Kashcow Ltd. All rights reserved
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';

const currentYear = new Date().getFullYear();

// Computed properties for environment variables
const portalLink = computed(() => process.env.VUE_APP_PORTAL_LINK);
const portalFaqsLink = computed(() => process.env.VUE_APP_PORTAL_LINK + 'page/faqs');
</script>

<style lang="scss" scoped>


.main-footer {
  background: var(--black);
  border: none;
  
  * {
    color: var(--primary);
    flex-direction: column;
    display: flex;
    align-items: center;
    text-align: center;

    @media (max-width: 992px) {
      text-align: center;
      width: auto;
    }

    .row {
      width: 100%;
    }
  }

  .footer-main {
    margin: 0 1rem;
  }
}
.footer-logo {
  max-width: 190px;
}
</style>
